<template>
  <svg
    :class="svgClass"
    aria-hidden="true">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps<{ name: string; class?: string }>()

  const svgClass = ['svg-icon', props.class].filter(Boolean).join(' ')
</script>

<style scoped>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
